import Colors, { withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Spacings, { createCustomSpacing, } from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
const VideoPlayerTheme = {
    videoPlayer: {
        light: {
            backgroundColor: Colors.black,
            skeleton: { backgroundColor: withOpacity(Colors.black, 0.5) },
            bufferBar: { backgroundColor: withOpacity(Colors.white, Opacities.low) },
            padding: {
                mobile: Spacings.medium,
                tablet: Spacings.medium,
                desktop: Spacings.xLarge,
            },
            color: Colors.white,
            controls: {
                backgroundColor: {
                    from: withOpacity(Colors.black, Opacities.none),
                    to: withOpacity(Colors.black, Opacities.medium),
                },
            },
            title: {
                color: Colors.white,
                backgroundColor: {
                    from: withOpacity(Colors.black, Opacities.none),
                    to: withOpacity(Colors.black, Opacities.low),
                },
            },
            initialPlayButton: {
                color: Colors.accessibleSafetyOrange,
                skeleton: {
                    color: withOpacity(Colors.black, Opacities.low),
                    backgroundColor: withOpacity(Colors.white, Opacities.medium),
                },
                backgroundColor: Colors.white,
                size: createCustomSpacing(5),
            },
            menu: {
                backgroundColor: Colors.white,
            },
            slider: {
                handleDotColor: Colors.white,
                handleCircleColor: withOpacity(Colors.white, Opacities.xLow),
                disabledColor: Colors.white,
                railColor: Colors.white,
                trackColor: withOpacity(Colors.white, Opacities.xLow),
            },
            endScreen: {
                backgroundColor: Colors.black,
            },
            actionButton: {
                states: {
                    enabled: {
                        labelColor: withOpacity(Colors.black, Opacities.medium),
                        backgroundColor: Colors.white,
                    },
                    hover: {
                        labelColor: Colors.black,
                        backgroundColor: Colors.white,
                    },
                },
                transparent: {
                    states: {
                        enabled: {
                            labelColor: Colors.white,
                            backgroundColor: Colors.transparent,
                        },
                        hover: {
                            labelColor: Colors.white,
                            backgroundColor: Colors.transparent,
                        },
                    },
                },
            },
        },
        dark: {},
    },
};
export default VideoPlayerTheme;
